import React, { useEffect } from 'react'
import { GlobalBox } from 'components/Box/GlobalBox'
import { InputsCancel } from './InputsCancel';
import { Box } from '@material-ui/core';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import { useSearch } from 'hooks/useSearch';
export const CancelAppView = () => {
  const {  buildCompLoadings} = useSearch()

  useEffect(() => {
    buildCompLoadings(['unitsSupportLoading','cancelAppLoading', 'printAppLoading'])
  }, [])
  return (
    <GlobalBox
      title="Soporte App"
      icon={<PhoneIphoneIcon />}
      style={{
        height: "85vh",
      }}
    >
      <Box style={{
        marginTop: 32,
        display: 'flex',
        justifyContent: 'center',
        padding: 16
      }}>
      <InputsCancel />
      </Box>
    </GlobalBox>
  )
}
